/* eslint-disable react/no-unused-prop-types */
// @flow
import React from 'react';
import type { Element } from 'react';
import type { GlobalState, I18nProps } from '@globalTypes';

import {
  faChevronLeft, faTimes, faBars, faPencilAlt
} from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { withTranslation } from 'react-i18next';
import { useRouter } from 'next/router';

// import { CTA_BUTTON } from '@components/StatefulButton/constants';
// import { StatefulButton } from '@components/index';

import {
  CONTACT_US,
  HOW_IT_WORKS,
  FINDER_FACILITY,
  FINDER_DOCTOR,
  FINDER_TREATMENT,
  BLOG,
  PROFILE_SUB_TAB,
  PROFILE_SETTINGS,
  MEDIMAKR_FRIENDS,
  PROFILE_LOGIN,
  DETAILS_PACKAGE,
  SIGN_IN,
  FORGOT_PASSWORD_SET,
  PACKAGE_PAYMENT,
  PAYMENT_SUCCESS,
  PROFILE_PACKAGE_FORM,
  SECOND_OPINION_PAYMENT,
  ONLINE_CONSULTATION_PAYMENT,
  FINDER_PACKAGE,
  CONSULTATION_MAIN_FLOW,
  OPINION_MAIN_FLOW,
  ONLINE_CONSULTATION,
  OPINION_PATIENT_FLOW,
  CONSULTATION_PATIENT_FLOW,
  TREATMENT_COST_FLOW,
  TREATMENT_PLAN_PATIENT_FLOW
  // FINDER_PACKAGE
} from '@routes';

import { Link } from '@i18n';

import WrapWithLink from '@components/WrapWithLink/index';
import { healthGPTRoute } from '@lib/healthGPTRoute';
import NavigationLink from '../NavigationLink';
import { StyledLinkNavigation } from '../NavigationLink/styles';
import LoginContainer from '../LoginContainer';
import {
  StyledSeparator,
  stylesMenu,
  StyledMobileMenuHeader,
  StyledMobileMenuBigHeader,
  StyledUserHeader,
  StyledAvatar,
  // StyledAvatarMain,
  StyledUserName,
  FontMianIcon,
  StyledUserNameIcon,
  StyledUserMail,
  StyledSubMenuLink,
  StyledCloseSubmenu,
  StyledMenu,
  StyledCtaContainer,
  StyledSubMenuWrapper,
} from './styles';

type PropsLoggedInLinks = {
  doLogout: Function
} & I18nProps;

type PropsMobileMenu = {
  username: string | typeof undefined,
  email: string | typeof undefined,
  avatarUrl: string | typeof undefined,
  doLogout: Function,
  doLogin: Function,
  isLoggedIn: boolean,
  routeName: string,
  setModalOpen: Function,
  invertCta: boolean,
  packageSlug?: string,
  curefyDomain: boolean,
  heroSection: boolean
} & I18nProps;

const LoggedInLinks = withTranslation('Profile')(
  ({ t, doLogout }: PropsLoggedInLinks): Element<any> => (
    <>
      <StyledSeparator />

      <Link
        href={PROFILE_SUB_TAB}
        passHref
        params={{ primaryTab: 'default', secondaryTab: 'dashboard' }}
      >
        <StyledLinkNavigation>{t('Menu.Dashboard')}</StyledLinkNavigation>
      </Link>
      {/*
      <Link href={RECOMMENDATIONS} passHref>
        <StyledLinkNavigation>{t('Menu.Recommendations')}</StyledLinkNavigation>
      </Link>
      */}
      <Link href={PROFILE_SETTINGS} passHref>
        <StyledLinkNavigation>{t('Menu.Settings')}</StyledLinkNavigation>
      </Link>

      <StyledSeparator />

      <StyledLinkNavigation onClick={doLogout}>{t('Menu.LogOut')}</StyledLinkNavigation>
    </>
  )
);

const SubMenu = withTranslation('Navigation')(({ parentMenu, t, close }) => {
  let menuItems: Element<any>;

  switch (parentMenu) {
    case 'community':
      menuItems = (
        <>
          <NavigationLink label={t('Testemonials')} route={BLOG} />
          <NavigationLink label={t('Pricing')} route={MEDIMAKR_FRIENDS} />
        </>
      );
      break;

    default:
      menuItems = (
        <>
          <NavigationLink label={t('DoctorFinder')} route={FINDER_DOCTOR} />
          <NavigationLink label={t('FacilityFinder')} route={FINDER_FACILITY} />
        </>
      );

      break;
  }

  return (
    <StyledSubMenuWrapper>
      <StyledCloseSubmenu onClick={close}>
        <FontAwesomeIcon icon={faChevronLeft} size="1x" />
        {t('MenuBack')}
      </StyledCloseSubmenu>

      {menuItems}
    </StyledSubMenuWrapper>
  );
});

const MobileMenu = ({
  username,
  email,
  avatarUrl,
  doLogout,
  doLogin,
  isLoggedIn,
  t,
  setModalOpen,
  packageSlug,
  curefyDomain,
  heroSection
}: PropsMobileMenu): Element<any> => {
  const [openMenu, setOpenMenu] = React.useState(false);
  const [openSubMenu, setOpenSubMenu] = React.useState({
    open: false,
    parentMenu: ''
  });

  const {
    query: { nextRoute: currentRoute }
  }: { query: { nextRoute: string } } = useRouter();

  // const ctaBlacklist: Array<string> = [CONTACT_US];

  const [curefyNavbar, setCurefyNavbar] = React.useState(false);
  React.useEffect(() => {
    if (curefyDomain === true) setCurefyNavbar(true);
  });

  const toSubMenu = (parentMenu: string): void => setOpenSubMenu({ open: true, parentMenu });
  const closeSubMenu = (): void => setOpenSubMenu({ open: false, parentMenu: '' });
  const onMenuStateChange = ({ isOpen }): void => {
    if (isOpen !== openMenu) {
      setOpenMenu(isOpen);
    }
  };

  // const onContactClick = (): void => {
  //   setNavbarVisibility(false);
  // };

  React.useEffect(() => {
    closeSubMenu();
    setOpenMenu(false);
  }, [currentRoute, isLoggedIn]);

  React.useEffect(() => {
    if (!document?.body?.setAttribute) return;

    if (openMenu) {
      (document.body: any).setAttribute('style', 'position: fixed; width: 100vw;');
    } else {
      (document.body: any).setAttribute('style', '');
    }
  }, [openMenu]);

  return (
    <>
      <WrapWithLink
        route={PROFILE_PACKAGE_FORM}
        params={{ slug: packageSlug }}
        doWrap={currentRoute === DETAILS_PACKAGE}
      >
        {!curefyNavbar
        && (
        <StyledCtaContainer
          hide={
            currentRoute === PROFILE_LOGIN
            || currentRoute === PROFILE_SUB_TAB
            || currentRoute === SIGN_IN
            || currentRoute === FORGOT_PASSWORD_SET
            || currentRoute === CONSULTATION_MAIN_FLOW
            || currentRoute === TREATMENT_COST_FLOW
            || currentRoute === TREATMENT_PLAN_PATIENT_FLOW
            || currentRoute === CONSULTATION_PATIENT_FLOW
            || currentRoute === ONLINE_CONSULTATION
            || currentRoute === OPINION_MAIN_FLOW
            || currentRoute === OPINION_PATIENT_FLOW
            || currentRoute === PACKAGE_PAYMENT
            || currentRoute === PAYMENT_SUCCESS
            || currentRoute === SECOND_OPINION_PAYMENT
            || currentRoute === ONLINE_CONSULTATION_PAYMENT
          }
          onClick={() => {
            // eslint-disable-next-line no-unused-expressions
            currentRoute === DETAILS_PACKAGE ? () => {} : setModalOpen(true);
          }}
        >
          {currentRoute === DETAILS_PACKAGE ? ' Book Package' : 'Get Started'}
        </StyledCtaContainer>
        ) }
      </WrapWithLink>

      <StyledMenu
        isOpen={openMenu}
        onStateChange={onMenuStateChange}
        width="70%"
        styles={stylesMenu({ heroSection })}
        customBurgerIcon={<FontAwesomeIcon icon={faBars} size="2x" />}
        customCrossIcon={<FontAwesomeIcon icon={faTimes} size="2x" />}
        disableAutoFocus
        right
      >
        <StyledMobileMenuBigHeader>
          <StyledMobileMenuHeader>
            {!isLoggedIn ? (
              <LoginContainer doLogin={doLogin} curefyNavbar={curefyNavbar} />

            ) : (
              <StyledUserHeader>
                <StyledAvatar src={avatarUrl} />
                <StyledUserNameIcon>
                  <StyledUserName>{username}</StyledUserName>
                  <FontMianIcon>
                    <Link
                      href={PROFILE_SETTINGS}
                      passHref
                      params={{
                        primaryTab: 'default',
                        secondaryTab: 'personal-info'
                      }}
                    >
                      <a className="svg-inline">
                        <FontAwesomeIcon icon={faPencilAlt} size="1x " />
                      </a>
                    </Link>
                  </FontMianIcon>
                </StyledUserNameIcon>
                <StyledUserMail>
                  <span>{email}</span>
                  {/* <Link
                    href={PROFILE_SETTINGS}
                    passHref
                    params={{
                      primaryTab: 'default',
                      secondaryTab: 'personal-info'
                    }}
                    >
                    <a>
                    <FontAwesomeIcon icon={faPencilAlt} size="1x" />
                    </a>
                  </Link> */}
                </StyledUserMail>
              </StyledUserHeader>
            )}
          </StyledMobileMenuHeader>


          { !openSubMenu.open
             && curefyNavbar
            ? (
              <>
                <StyledSubMenuWrapper>
                  <NavigationLink label={t('HealthGPT')} route={healthGPTRoute} />
                  <NavigationLink label={t('OnlineConsultationSecond')} route={CONSULTATION_MAIN_FLOW} />
                  {isLoggedIn && <LoggedInLinks doLogout={doLogout} />}
                </StyledSubMenuWrapper>
              </>
            ) : <></>}

          {!openSubMenu.open && !curefyNavbar ? (

            <StyledSubMenuWrapper>
              {/* <NavigationLink label={t('Home')} route={INDEX} />
            <NavigationLink label="About us" route={ABOUT_US} /> */}
              <NavigationLink label={t('HowItWorks')} route={HOW_IT_WORKS} />

              {/* <NavigationLink label={t('OnlineConsultation')} route={ONLINE_CONSULTATION} /> */}
              <NavigationLink label={t('Contact')} route={CONTACT_US} />
              <StyledSubMenuLink
                isActive={[FINDER_FACILITY, FINDER_DOCTOR].includes(currentRoute)}
                onClick={() => toSubMenu('explore')}
              >
                {t('Explore')}
              </StyledSubMenuLink>
              {/* <NavigationLink label={t('Contact')} route={CONTACT} /> */}

              <NavigationLink label={t('TreatmentFinder')} route={FINDER_TREATMENT} />
              <NavigationLink label={t('Packages')} route={FINDER_PACKAGE} />

              {/* <NavigationLink label={t('Login')} route={PROFILE_LOGIN} /> */}
              {/* <StyledSubMenuLink
              isActive={[BLOG].includes(currentRoute)}
              onClick={() => toSubMenu('community')}
              >
              {t('Stories')}
              <FontAwesomeIcon icon={faChevronRight} size="sm" />
            </StyledSubMenuLink> */}

              {isLoggedIn && <LoggedInLinks doLogout={doLogout} />}
            </StyledSubMenuWrapper>
          )
            : <></>}
          { openSubMenu.open
          && (<SubMenu parentMenu={openSubMenu.parentMenu} t={t} close={closeSubMenu} />)}
        </StyledMobileMenuBigHeader>
      </StyledMenu>
    </>
  );
};


const mapStateToProps = ({ packageDetails, page }: GlobalState): {} => ({
  packageSlug: packageDetails?.data?.attributes?.slug,
  curefyDomain: page.curefyDomain
});

export default compose(
  withTranslation('Navigation'),
  connect(mapStateToProps)
)(MobileMenu);
